import { CompanyDto } from '@billing/app/api'
import { CompanyStore } from '@billing/stores/CompanyStore'
import { BaseDrawerStore } from '@billing/stores/base/BaseDrawerStore'
import { action, makeObservable, observable } from 'mobx'
import { CompanyFormProfile } from '../components/form/company-form.profile'

export class CompanyDialogUIStore extends BaseDrawerStore<CompanyDto> {
  isDeleteOpen = false
  skipCancellableRequest = false
  defaultCompanyData?: CompanyDto
  onSaveCallback?: (data: CompanyFormProfile) => void

  constructor(private companyStore: CompanyStore) {
    super(companyStore)
    makeObservable(this, {
      isDeleteOpen: observable,
      defaultCompanyData: observable,
      skipCancellableRequest: observable,

      toggleDelete: action,
      openWithDefaultData: action,
      setSkipCancellableRequest: action,
      reset: action,
    })
  }

  public toggleDelete(): void {
    this.isDeleteOpen = !this.isDeleteOpen
  }

  public openWithDefaultData(companyData?: CompanyDto, callback?: () => void): void {
    this.isOpen = !this.isOpen
    this.onSaveCallback = callback
    if (companyData) {
      this.defaultCompanyData = companyData
    }
  }

  setSkipCancellableRequest(skip: boolean): void {
    this.skipCancellableRequest = skip
  }

  reset() {
    this.defaultCompanyData = undefined
    this.onSaveCallback = undefined
    this.skipCancellableRequest = false
  }
}
